<h3>Platform Configurations main page</h3>
